import NivelService from "../../services/LevelService";
import GradoService from "../../services/GradesService";
import SesionsService from "../../services/SesionsService";
import UsersService from "../../services/UsersService";
import LoginService from "../../services/LoginService";
import InstitucionEService from "../../services/InstitucionE";

export const cargarUsuarios = (params = {}) => UsersService.obtenerUsersConInstituciones(params);
export const cargarNiveles = () => NivelService.listarNiveles();
export const cargarGrados = (nivelId) => NivelService.listarGradosPorNivel(nivelId);
export const cargarAreas = (gradoId) => GradoService.listarAreasPorGrado(gradoId);
export const cargarRegiones = () => LoginService.getRegiones();
export const cargarProvincias = (regionId) => LoginService.getProvincias(regionId);
export const cargarDistritos = (provinciaId) => LoginService.getDistritos(provinciaId);
export const cargarIe = (filtros) => InstitucionEService.listarInstituciones(filtros);

export const buscarSesiones = async ({
  filtros,
  page,
  rowsPerPage,
}) => {
  const payload = {
    ...filtros,
    skip: page * rowsPerPage,
    limit: rowsPerPage,
  };
  return SesionsService.obtenerSesiones(payload);
};
